var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 42.75H8L7.25 45.75H24.5V42.75H9.5Z",
    fill: "#808285"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 42.75H39.5H24.5V45.75H41.75L41 42.75Z",
    fill: "#8E9093"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 38.25H12.5H11L9.5 42.75H24.5V38.25Z",
    fill: "#57A4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 42.75H39.5L38 38.25H36.5H24.5V42.75Z",
    fill: "#6AAEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 35.25H14.75H13.25L12.5 38.25H24.5V35.25Z",
    fill: "#A7A9AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 38.25H36.5L35.75 35.25H34.25H24.5V38.25Z",
    fill: "#BCBEC0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 35.25H34.25L32 14.25H24.5V35.25Z",
    fill: "#D6EAF9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 14.25H17L14.75 35.25H24.5V14.25Z",
    fill: "#C2DFF6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 2.25H23V5.25H20V2.25H17V5.25H14V2.25H11V11.25H17H24.5V2.25Z",
    fill: "#9BC9FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32 11.25H38V2.25H35V5.25H32V2.25H29V5.25H26V2.25H24.5V11.25H32Z",
    fill: "#BDDBFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 11.25H17V14.25H24.5V11.25Z",
    fill: "#A7A9AC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32 11.25H24.5V14.25H32V11.25Z",
    fill: "#BCBEC0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3743 20.1958L28.8828 20.3555L30.1652 32.3313L31.6567 32.1715L30.3743 20.1958Z",
    fill: "#F1F2F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.05 17.1716L28.5586 17.332L28.7164 18.7988L30.2078 18.6384L30.05 17.1716Z",
    fill: "#F1F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChess);
export default __webpack_public_path__ + "static/media/chess.d6783d5134fd49234b96a98a4db3a0e4.svg";
export { ForwardRef as ReactComponent };